import { render, staticRenderFns } from "./admin-side.vue?vue&type=template&id=56ae5384&scoped=true"
import script from "./admin-side.vue?vue&type=script&lang=ts"
export * from "./admin-side.vue?vue&type=script&lang=ts"
import style0 from "./admin-side.vue?vue&type=style&index=0&id=56ae5384&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ae5384",
  null
  
)

export default component.exports